import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';

import {Translate} from 'views/module';

import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';

import AddCaregiver from './AddCaregiver';
import CaregiverView from './CaregiverView';

const CaregiverConnection = (props) => {
  const [model, setModel] = React.useState({});

  const clientData = props.clientData;
  const clientBackend = props.clientBackend;

  const caregivers = clientData.caregivers;

  const openDialogs = {
    close: () => {
      setModel({});
    },
    addCaregiver: () => {
      setModel({action: 'ADD_CAREGIVER'});
    },
  };

  const edits = {
    addCaregiver: (caregiverRn) => {
      const complete = () => {
        setModel({});
      };

      clientBackend.detail.addCaregiver(caregiverRn, complete);
    },
    removeCaregiver: (caregiverRn) => {
      const complete = () => {
        setModel({});
      };

      clientBackend.detail.removeCaregiver(caregiverRn, complete);
    },
  };

  const popModelGenerator = React.useCallback(() => {
    let popModel = null;
    if (model.action === 'ADD_CAREGIVER') {
      popModel = <AddCaregiver
        onClose={openDialogs.close}
        addCaregiver={edits.addCaregiver}
      />;
    }
    return popModel;
  }, [model]);

  return (
    <Stack
      sx={{
      }}
    >
      {popModelGenerator()}
      {
        Object.values(caregivers).map((e, index) => {
          return (
            <CaregiverView
              key={index}
              caregiver={e}
              removeCaregiver={edits.removeCaregiver}
            />
          );
        })
      }
      <Button
        startIcon={<AddCircleOutlineIcon />}
        onClick={openDialogs.addCaregiver}
        sx={{
          mx: 2,
          my: 1,
        }}
      >
        <Translate expression='client.ClientDetail.CaregiverConnections.AddCaregiver.Title' />
      </Button>
    </Stack>
  );
};

CaregiverConnection.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};
export default React.memo(CaregiverConnection);
